export const SUB_JOB_ISSUE_TRANSACTION_REQUEST = 'SUB_JOB_ISSUE_TRANSACTION_REQUEST';
export const SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE = 'SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE';
export const GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO = 'GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO';
export const GET_SUB_JOB_ISSUE_TRANSACTIONS = 'GET_SUB_JOB_ISSUE_TRANSACTIONS';